import React, { useState } from 'react';
import api from '../utils/requests/base';
import { useNavigate } from "react-router-dom";


const AddUserLayer = () => {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        phoneNumber: '',
        email: ''
    });
    const navigate = useNavigate();

    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [submitMessage, setSubmitMessage] = useState('');

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setErrors({});
        setSubmitMessage('');

        try {
            const response = await api.post('/teacher/students/create', formData);

            if (response.data) {
                // Reset form
                setFormData({
                    firstName: '',
                    lastName: '',
                    phoneNumber: '',
                    email: ''
                });
                navigate('/users-list')
            }
        } catch (error) {
            if (error.response?.data?.error) {
                const { message, fields } = error.response.data.error;

                if (fields) {
                    // Parse fields string and set errors for each field
                    const fieldErrors = {};
                    fields.split(',').forEach(field => {
                        const trimmedField = field.trim();
                        fieldErrors[trimmedField] = message;
                    });
                    setErrors(fieldErrors);
                } else {
                    setSubmitMessage(message);
                }
            } else {
                setSubmitMessage('אירעה שגיאה ביצירת המשתמש');
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="p-0 radius-12">
            <div className="p-24">
                <div className="row justify-content-center">
                    <div className="col-xxl-6 col-xl-8 col-lg-10">
                        <div className="card border">
                            <div className="card-body">
                                <h6 className="text-md text-primary-light mb-16">הוספת תלמיד חדש</h6>

                                {submitMessage && (
                                    <div className={`alert ${submitMessage.includes('בהצלחה') ? 'alert-success' : 'alert-danger'} mb-20`}>
                                        {submitMessage}
                                    </div>
                                )}

                                <form onSubmit={handleSubmit}>
                                    <div className="mb-20">
                                        <label
                                            htmlFor="firstName"
                                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                                        >
                                            שם פרטי
                                        </label>
                                        <input
                                            type="text"
                                            className={`form-control radius-8 ${errors.firstName ? 'border-danger' : ''}`}
                                            id="firstName"
                                            name="firstName"
                                            value={formData.firstName}
                                            onChange={handleInputChange}
                                            placeholder="הכנס שם פרטי"
                                        />
                                        {errors.firstName && (
                                            <div className="text-danger text-sm mt-2">{errors.firstName}</div>
                                        )}
                                    </div>

                                    <div className="mb-20">
                                        <label
                                            htmlFor="lastName"
                                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                                        >
                                            שם משפחה
                                        </label>
                                        <input
                                            type="text"
                                            className={`form-control radius-8 ${errors.lastName ? 'border-danger' : ''}`}
                                            id="lastName"
                                            name="lastName"
                                            value={formData.lastName}
                                            onChange={handleInputChange}
                                            placeholder="הכנס שם משפחה"
                                        />
                                        {errors.lastName && (
                                            <div className="text-danger text-sm mt-2">{errors.lastName}</div>
                                        )}
                                    </div>

                                    <div className="mb-20">
                                        <label
                                            htmlFor="phoneNumber"
                                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                                        >
                                            מספר נייד <span className="text-danger-600">*</span>
                                        </label>
                                        <input
                                            type="tel"
                                            className={`form-control radius-8 ${errors.phoneNumber ? 'border-danger' : ''}`}
                                            id="phoneNumber"
                                            name="phoneNumber"
                                            value={formData.phoneNumber}
                                            onChange={handleInputChange}
                                            placeholder="הכנס מספר נייד"
                                        />
                                        {errors.phoneNumber && (
                                            <div className="text-danger text-sm mt-2">{errors.phoneNumber}</div>
                                        )}
                                    </div>

                                    <div className="mb-20">
                                        <label
                                            htmlFor="email"
                                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                                        >
                                            כתובת אימייל
                                        </label>
                                        <input
                                            type="email"
                                            className={`form-control radius-8 ${errors.email ? 'border-danger' : ''}`}
                                            id="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleInputChange}
                                            placeholder="הכנס כתובת אימייל"
                                        />
                                        {errors.email && (
                                            <div className="text-danger text-sm mt-2">{errors.email}</div>
                                        )}
                                    </div>

                                    <div className="d-flex align-items-center justify-content-center gap-3">
                                        <button
                                            type="button"
                                            className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-56 py-11 radius-8"
                                            onClick={() => {
                                                setFormData({
                                                    firstName: '',
                                                    lastName: '',
                                                    phoneNumber: '',
                                                    email: ''
                                                });
                                                setErrors({});
                                                setSubmitMessage('');
                                            }}
                                        >
                                            ביטול
                                        </button>
                                        <button
                                            type="submit"
                                            className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                                            disabled={isLoading}
                                        >
                                            {isLoading ? 'שומר...' : 'שמור'}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddUserLayer;